import EndpointComp from 'developer-docs-shared-components/components/endpoint/EndpointComp';
import { jsx as _jsx } from "react/jsx-runtime";
function Endpoint({
  method,
  path
}) {
  return /*#__PURE__*/_jsx(EndpointComp, {
    marginBlockEnd: "600",
    method: method,
    path: path
  });
}
export default Endpoint;